/* ============================================================
   White Nights — global.js  (vanilla, no dependencies)
   Wires the design to Shopify's Cart AJAX API + UI behaviour.
   ============================================================ */
(function () {
  'use strict';

  var T = window.theme || {};
  var cfg = T.settings || {};
  var strings = T.strings || {};

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    format = format || T.moneyFormat || '₹{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(n, p, t, d) {
      n = (n || 0).toString();
      p = p == null ? 2 : p; t = t == null ? ',' : t; d = d == null ? '.' : d;
      var parts = (parseInt(n, 10) / 100).toFixed(p).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      var centsStr = parts[1] ? d + parts[1] : '';
      return dollars + centsStr;
    }
    switch ((format.match(placeholderRegex) || [])[1]) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      default: value = defaultTo(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }, opts))
      .then(function (r) { return r.json(); });
  }

  /* ============================================================
     CART
     ============================================================ */
  var Cart = {
    open: function () {
      var ov = $('#CartOverlay'), dr = $('#CartDrawer');
      if (!dr) { window.location.href = T.routes.cart_url || '/cart'; return; }
      ov && ov.classList.add('is-open');
      dr.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.refresh();
    },
    close: function () {
      var ov = $('#CartOverlay'), dr = $('#CartDrawer');
      ov && ov.classList.remove('is-open');
      dr && dr.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    add: function (id, qty) {
      return fetchJSON((T.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function () { return Cart.refresh(); }).then(function () { Cart.open(); });
    },
    change: function (key, qty) {
      return fetchJSON((T.routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST', body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (cart) { Cart.render(cart); return cart; });
    },
    updateNote: function (note) {
      return fetchJSON((T.routes.cart_update_url || '/cart/update') + '.js', {
        method: 'POST', body: JSON.stringify({ note: note })
      });
    },
    setAttribute: function (key, val) {
      var attrs = {}; attrs[key] = val;
      return fetchJSON((T.routes.cart_update_url || '/cart/update') + '.js', {
        method: 'POST', body: JSON.stringify({ attributes: attrs })
      });
    },
    refresh: function () {
      return fetchJSON((T.routes.cart_url || '/cart') + '.js').then(function (cart) { Cart.render(cart); return cart; });
    },
    render: function (cart) {
      // bag counters
      $all('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      var body = $('#CartBody'); if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p>' + (strings.cart_empty || 'Your bag is empty.') + '</p><a class="link-underline mt-m" href="' + (T.routes.all_products || '/collections/all') + '">' + (strings.cart_continue || 'Continue shopping') + '</a></div>';
        var foot = $('#CartFoot'); if (foot) foot.style.display = 'none';
        return;
      }
      var foot = $('#CartFoot'); if (foot) foot.style.display = '';

      // free shipping progress
      var ship = $('#CartShip');
      if (ship && cfg.free_shipping_bar) {
        var thr = parseInt(cfg.free_shipping_threshold, 10) || 0;
        var remain = Math.max(0, thr - cart.total_price);
        var msg = remain > 0
          ? (strings.ship_progress || 'You’re {{ amount }} away from free shipping').replace('{{ amount }}', formatMoney(remain))
          : (strings.ship_unlocked || '✦ You’ve unlocked free shipping');
        var pct = thr ? Math.min(100, Math.round(cart.total_price / thr * 100)) : 100;
        ship.querySelector('[data-ship-msg]').textContent = msg;
        ship.querySelector('[data-ship-bar]').style.width = pct + '%';
      }

      // line items
      var rows = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image.replace(/(\.[^.]*)$/, '_160x$1') + '" alt="' + it.product_title + '">' : '';
        var opts = it.options_with_values ? it.options_with_values.map(function (o) { return o.value; }).join(' · ') : '';
        return '' +
          '<div class="line" data-key="' + it.key + '">' +
            '<div class="line__media">' + img + '</div>' +
            '<div style="flex:1">' +
              '<div class="line__top">' +
                '<div class="line__title">' + it.product_title + '</div>' +
                '<button class="line__remove" data-line-remove>' + (strings.remove || 'Remove') + '</button>' +
              '</div>' +
              '<div class="line__variant">' + opts + '</div>' +
              '<div class="line__bottom">' +
                '<div class="qty">' +
                  '<button data-qty-dec aria-label="Decrease">−</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button data-qty-inc aria-label="Increase">+</button>' +
                '</div>' +
                '<span>' + formatMoney(it.final_line_price) + '</span>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');

      var listEl = $('#CartLines'); if (listEl) listEl.innerHTML = rows;
      var sub = $('#CartSubtotal'); if (sub) sub.textContent = formatMoney(cart.total_price);
      var coBtn = $('#CartCheckoutAmount'); if (coBtn) coBtn.textContent = formatMoney(cart.total_price);
      // restore note
      var noteEl = $('#CartNote'); if (noteEl && cart.note) noteEl.value = cart.note;
    }
  };
  window.WNCart = Cart;

  /* ---------- event delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // open/close cart
    if (t.closest('[data-cart-toggle]')) { e.preventDefault(); Cart.open(); return; }
    if (t.closest('[data-cart-close]') || t.id === 'CartOverlay') { Cart.close(); return; }

    // add to cart (cross-sell / quick buttons with data-variant-id)
    var addBtn = t.closest('[data-add-variant]');
    if (addBtn) { e.preventDefault(); Cart.add(addBtn.getAttribute('data-add-variant'), 1); return; }

    // qty controls inside drawer
    var line = t.closest('.line');
    if (line) {
      var key = line.getAttribute('data-key');
      var qtyEl = line.querySelector('.qty span');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (t.closest('[data-qty-inc]')) { Cart.change(key, current + 1); return; }
      if (t.closest('[data-qty-dec]')) { Cart.change(key, Math.max(0, current - 1)); return; }
      if (t.closest('[data-line-remove]')) { Cart.change(key, 0); return; }
    }

    // in-store pickup toggle
    var pickup = t.closest('[data-pickup-toggle]');
    if (pickup) {
      var on = pickup.classList.toggle('is-on');
      Cart.setAttribute('Pickup', on ? 'White Nights · Bandra, Mumbai' : '');
      return;
    }

    // quick view
    var qv = t.closest('[data-quick-view]');
    if (qv) { e.preventDefault(); QuickView.open(qv.getAttribute('data-quick-view')); return; }

    // mobile menu
    if (t.closest('[data-menu-open]')) { MobileMenu.open(); return; }
    if (t.closest('[data-menu-close]') || t.classList.contains('mobile-nav__overlay')) { MobileMenu.close(); return; }

    // mobile sticky add-to-cart -> submit the PDP form
    if (t.closest('[data-mobile-add]')) {
      e.preventDefault();
      var pform = $('[data-product-form]');
      if (pform) { if (pform.requestSubmit) pform.requestSubmit(); else pform.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
      return;
    }

    // modal close
    if (t.closest('[data-modal-close]') || t.hasAttribute('data-modal-overlay')) {
      var m = t.closest('.modal'); if (m) m.classList.remove('is-open');
      document.body.style.overflow = ''; return;
    }

    // open age / promo from footer
    if (t.closest('[data-open-age]')) { openModal('AgeModal'); return; }
    if (t.closest('[data-open-promo]')) { openModal('PromoModal'); return; }
    if (t.closest('[data-open-size-chart]')) { openModal('SizeChartModal'); return; }

    // image zoom (PDP)
    if (t.closest('[data-zoom]')) { Zoom.toggle(t.closest('[data-zoom]')); return; }
  });

  // product form submit (PDP add to cart)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '…'; }
    Cart.add(id, qty).finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } });
  });

  // cart note (debounced)
  document.addEventListener('input', function (e) {
    if (e.target.id === 'CartNote') {
      clearTimeout(window._noteT);
      var v = e.target.value;
      window._noteT = setTimeout(function () { Cart.updateNote(v); }, 500);
    }
  });

  /* ============================================================
     MOBILE MENU
     ============================================================ */
  var MobileMenu = {
    open: function () {
      var nav = $('#MobileNav'), ov = $('.mobile-nav__overlay');
      if (ov) { ov.hidden = false; requestAnimationFrame(function () { ov.classList.add('is-open'); }); }
      if (nav) nav.classList.add('is-open');
      var btn = $('[data-menu-open]'); if (btn) btn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      var nav = $('#MobileNav'), ov = $('.mobile-nav__overlay');
      if (nav) nav.classList.remove('is-open');
      if (ov) { ov.classList.remove('is-open'); setTimeout(function () { ov.hidden = true; }, 300); }
      var btn = $('[data-menu-open]'); if (btn) btn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  };

  /* ============================================================
     SCROLL REVEALS
     ============================================================ */
  function initReveals() {
    var els = $all('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }
  window.WNInitReveals = initReveals;

  /* ============================================================
     QUICK VIEW  (Section Rendering API)
     ============================================================ */
  var QuickView = {
    open: function (handle) {
      var modal = $('#QuickViewModal'); if (!modal) return;
      var body = modal.querySelector('[data-quick-view-content]');
      body.innerHTML = '<div style="padding:60px;text-align:center" class="muted">Loading…</div>';
      openModal('QuickViewModal');
      fetch('/products/' + handle + '?section_id=quick-view')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('.shopify-section') || doc.body;
          body.innerHTML = content.innerHTML;
          if (window.WNInitProduct) window.WNInitProduct(body);
        })
        .catch(function () { body.innerHTML = '<div style="padding:60px" class="muted">Could not load product.</div>'; });
    }
  };

  /* ============================================================
     IMAGE ZOOM (PDP)
     ============================================================ */
  var Zoom = {
    toggle: function (el) {
      var src = el.getAttribute('data-zoom-src') || (el.querySelector('img') && el.querySelector('img').src);
      if (!src) return;
      var existing = $('#ZoomOverlay');
      if (existing) { existing.remove(); document.body.style.overflow = ''; return; }
      var ov = document.createElement('div');
      ov.id = 'ZoomOverlay';
      ov.style.cssText = 'position:fixed;inset:0;background:rgba(33,29,24,.92);z-index:120;display:grid;place-items:center;cursor:zoom-out;padding:40px';
      ov.innerHTML = '<img src="' + src + '" style="max-width:90%;max-height:90%;object-fit:contain">';
      ov.addEventListener('click', function () { ov.remove(); document.body.style.overflow = ''; });
      document.body.appendChild(ov);
      document.body.style.overflow = 'hidden';
    }
  };

  /* ============================================================
     MODALS (age gate + promo popup)
     ============================================================ */
  function openModal(id) { var m = document.getElementById(id); if (m) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeModal(id) { var m = document.getElementById(id); if (m) { m.classList.remove('is-open'); document.body.style.overflow = ''; } }

  document.addEventListener('DOMContentLoaded', function () {
    Cart.refresh();

    // PDP variant + gallery
    initProduct(document);
    initFacets();
    initReveals();
    RecentlyViewed.run();

    // Age gate
    var age = $('#AgeModal');
    if (age && age.getAttribute('data-enabled') === 'true' && !sessionStorage.getItem('wn_age')) {
      openModal('AgeModal');
    }
    var ageYes = $('[data-age-confirm]');
    if (ageYes) ageYes.addEventListener('click', function () {
      sessionStorage.setItem('wn_age', '1'); closeModal('AgeModal'); maybePromo(1600);
    });

    if (!age || sessionStorage.getItem('wn_age')) maybePromo(3500);
  });

  function maybePromo(delay) {
    var promo = $('#PromoModal');
    if (!promo || promo.getAttribute('data-enabled') !== 'true') return;
    if (sessionStorage.getItem('wn_promo')) return;
    setTimeout(function () {
      openModal('PromoModal');
      sessionStorage.setItem('wn_promo', '1');
    }, delay || 3000);
  }

  /* ============================================================
     PRODUCT PAGE — variant selection + gallery + tabs
     ============================================================ */
  function initProduct(scope) {
    scope = scope || document;
    var root = (scope.matches && scope.matches('[data-product-root]')) ? scope : scope.querySelector('[data-product-root]');
    if (!root) return;
    var variants = JSON.parse(root.getAttribute('data-variants') || '[]');
    var form = root.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var addBtn = form && form.querySelector('[type="submit"]');

    function selectedOptions() {
      return $all('[data-option-selector]', root).map(function (group) {
        var checked = group.querySelector('input:checked') || group.querySelector('[data-option-value].is-active');
        return checked ? (checked.value || checked.getAttribute('data-option-value')) : null;
      });
    }
    function update() {
      var opts = selectedOptions();
      var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      // keep mobile sticky bar price in sync (it lives outside the product root)
      var mAtcPrice = document.querySelector('[data-mobile-atc] [data-pdp-price]');
      if (mAtcPrice) mAtcPrice.textContent = formatMoney(match.price);
      var mAdd = document.querySelector('[data-mobile-add]');
      if (mAdd) {
        mAdd.disabled = !match.available;
        mAdd.textContent = match.available ? (strings.add_to_cart || 'Add to bag') : (strings.sold_out || 'Sold out');
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (strings.add_to_cart || 'Add to bag') : (strings.sold_out || 'Sold out');
      }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-selector]')) update(); });
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-option-value]');
      if (sw) {
        var grp = sw.closest('[data-option-selector]');
        $all('[data-option-value]', grp).forEach(function (x) { x.classList.remove('is-active'); });
        sw.classList.add('is-active'); update();
      }
    });

    // gallery
    var mainImg = root.querySelector('[data-pdp-main] img');
    $all('[data-pdp-thumb]', root).forEach(function (th) {
      th.addEventListener('click', function () {
        $all('[data-pdp-thumb]', root).forEach(function (x) { x.classList.remove('is-active'); });
        th.classList.add('is-active');
        if (mainImg) { mainImg.src = th.getAttribute('data-full'); root.querySelector('[data-pdp-main]').setAttribute('data-zoom-src', th.getAttribute('data-full')); }
      });
    });
    update();
  }
  window.WNInitProduct = initProduct;

  /* ============================================================
     RECENTLY VIEWED (localStorage + Section Rendering)
     ============================================================ */
  var RecentlyViewed = {
    KEY: 'wn_recent',
    read: function () { try { return JSON.parse(localStorage.getItem(this.KEY)) || []; } catch (e) { return []; } },
    write: function (a) { try { localStorage.setItem(this.KEY, JSON.stringify(a.slice(0, 8))); } catch (e) {} },
    run: function () {
      var list = this.read();
      var current = (window.WNRecentQueue || []);
      // record current product(s)
      current.forEach(function (h) {
        list = list.filter(function (x) { return x !== h; });
        list.unshift(h);
      });
      if (current.length) this.write(list);

      var container = document.getElementById('RecentlyViewed');
      if (!container) return;
      var toShow = this.read().filter(function (h) { return current.indexOf(h) === -1; }).slice(0, 4);
      if (!toShow.length) return;
      var section = document.getElementById('RecentlyViewedSection');
      Promise.all(toShow.map(function (h) {
        return fetch('/products/' + h + '?section_id=card').then(function (r) { return r.text(); }).catch(function () { return ''; });
      })).then(function (htmls) {
        var out = '';
        htmls.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('.card');
          if (card) out += card.outerHTML;
        });
        if (out) { container.innerHTML = out; if (section) section.hidden = false; }
      });
    }
  };

  /* ============================================================
     COLLECTION — auto-submit facets / sort
     ============================================================ */
  function initFacets() {
    var form = $('#FacetForm'); if (!form) return;
    form.addEventListener('change', function () { form.submit(); });
    var sort = $('#SortBy');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.href = url.toString();
    });
  }
})();
